import Joi from 'joi';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
const listingProjectBlockSchema = Joi.object({
  type: Joi.string().valid('listingProjectBlock').required(),
  code: Joi.string().allow('', null).required(),
  quantity: Joi.string().required(),
  interiorDesign: Joi.array().items(Joi.object().keys({
    baseData: Joi.object().unknown(true).required()
  }).unknown(true)).allow(null),
  inspirationTags: Joi.object().unknown(true).allow(null),
  ...blockAppearanceSchema
}).unknown(true);
export default listingProjectBlockSchema;